/**
 * Page-aware tracking for the shared form selectors (Country / Date / Traveller).
 *
 * These selectors are rendered on both the common-landing page and inside the
 * listing page's ContextEdit. The same interaction must fire the correct page
 * name in each place, so the parent passes a `trackingSource` and this helper
 * routes to the matching Omniture event (plus a common XDM event).
 */
import { getAnalytics } from "@tm/insurance/analytics";
import { trackEvent } from "@tm/insurance/analytics/xdm";

export type SelectorTrackingSource = "common_landing" | "listing" | "traveller";

interface TrackSelectorOptions {
  /** Omniture interaction payload (e.g. { departure, arrival }). */
  payload?: Record<string, unknown>;
  /** Plan type suffix appended to the Omniture page name, when known. */
  type?: string;
  /** Optional XDM search context (dates) merged into the event. */
  searchContext?: { fromDateTime?: number; toDateTime?: number };
}

export function trackSelectorEvent(
  source: SelectorTrackingSource,
  actionType: string,
  options?: TrackSelectorOptions
) {
  const analytics = getAnalytics();
  try {
    if (source === "listing") {
      analytics?.trackListingEvents(
        { actionType, payload: options?.payload } as any,
        "click",
        options?.type,
        true
      );
    } else if (source === "traveller") {
      analytics?.trackTravDetailsEvents(
        { actionType, payload: options?.payload } as any,
        "click",
        options?.type
      );
    } else {
      analytics?.trackCommonLandingEvents(
        { actionType, payload: options?.payload } as any,
        "click"
      );
    }

    trackEvent(
      {
        event_detail: {
          event_type: "action",
          event_name: "component_cta-clicked",
          event_value: actionType,
        },
      },
      options?.searchContext
    );
  } catch (err) {
    console.error(`[tracking] ${actionType} failed`, err);
  }
}
